module.exports = __webpack_public_path__ + "img/receipt22.28b3fb5d.png";